/* eslint-disable react/no-array-index-key */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FC } from 'react';
import { explanationParagraphs } from './constant';
import Score from './Score';
import style from './style';

interface IProps {
  data: any;
}

const Explanation: FC<IProps> = ({ data: { data } }) => {
  const classes = style();
  const { key, ...rest } = data?.treeMax[0];
  return (
    <Grid justifyContent="center" alignItems="center" container={true}>
      <Grid className={classes.resultImgContainer} item={true} sm={12} md={6}>
        <img className={classes.resultImg} src={`${data.favorite.img}`} alt="Competitor" />
      </Grid>
      <Grid className={classes.scoreItemContainer} item={true} sm={12} md={6}>
        <Score score={rest} />
      </Grid>
      <Grid className={classes.explanationTextContainer} item={true} md={12}>
        {explanationParagraphs[key].map((paragraph: string, index: number) => (
          <Typography key={index} className={classes.explanationText} component="p">
            {paragraph}
          </Typography>
        ))}
      </Grid>
    </Grid>
  );
};

export default Explanation;
